import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { TranslateLoader, TranslationObject } from "@ngx-translate/core";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { AppSettings } from "app/app.settings";

/**
 * Loads all MC_ text fragments of a language in one request.
 * Keys that are not in the result keep going through the MissingTranslationHandler.
 */
@Injectable()
export class TextFragmentLoader implements TranslateLoader {
   private http = inject(HttpClient);
   private appSettings = inject(AppSettings);

   public getTranslation(lang: string): Observable<TranslationObject> {
      const uri = `${this.appSettings.baseCoreApiUrl}/text-fragments?language=${this.toLanguageCode(lang)}`;
      const headers = new HttpHeaders().set("X-MY-CLOUD-No-Response-Toast", "true");

      // on failure every key falls back to the per key request of the MissingTranslationHandler
      return this.http.get<TranslationObject>(uri, { headers }).pipe(catchError(_ => of({})));
   }

   // translate.use() receives the locale (see AppSettings.selectedLanguageLocale), the API expects N, F or E
   private toLanguageCode(locale: string): string {
      switch (locale) {
         case "nl":
            return "N";
         case "fr":
            return "F";
         default:
            return "E";
      }
   }
}
